import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Analyze from "@/pages/Analyze";
import Report from "@/pages/Report";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ComeFunziona from "@/pages/ComeFunziona";
import EsempioReport from "@/pages/EsempioReport";
import Prezzi from "@/pages/Prezzi";
import Metodologia from "@/pages/Metodologia";
import ChiSiamo from "@/pages/ChiSiamo";
import Guide from "@/pages/Guide";
import PreventiviHub from "@/pages/PreventiviHub";
import Contatti from "@/pages/Contatti";
import LegalPage from "@/pages/LegalPage";
import AdminMetrics from "@/pages/AdminMetrics";
import CookieConsent from "@/components/CookieConsent";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);
  useEffect(() => {
    if (hash) return; // anchor intenzionale (es. /#faq): lascia la gestione all'ancora
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto"; // reset immediato, bypassa scroll-behavior:smooth globale
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/controlla-preventivo" element={<Analyze />} />
          <Route path="/analisi" element={<Analyze />} />
          <Route path="/report/:token" element={<Report />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/come-funziona" element={<ComeFunziona />} />
          <Route path="/esempio-report" element={<EsempioReport />} />
          <Route path="/prezzi" element={<Prezzi />} />
          <Route path="/metodologia" element={<Metodologia />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/faq" element={<Navigate to="/#faq" replace />} />
          <Route path="/guide" element={<Navigate to="/come-funziona" replace />} />
          <Route path="/preventivi" element={<PreventiviHub />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy-policy" element={<LegalPage />} />
          <Route path="/cookie-policy" element={<LegalPage />} />
          <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
          <Route path="/cookie" element={<Navigate to="/cookie-policy" replace />} />
          <Route path="/termini" element={<LegalPage />} />
          <Route path="/disclaimer" element={<LegalPage />} />
          <Route path="/admin-okkio-metrics" element={<AdminMetrics />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
